import React, { useState } from 'react'

import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { StyledLink } from 'shared/components/Typography'
import {
    StyledConfirmationContainer,
    StyledSubtext,
} from 'shared/pages/SignUpSignIn/styled'
import SignUpSignIn from '..'

export interface ConfirmationProps {
    subtitle: string
    blurb: string
    onClickResend: () => void
}

const Confirmation: React.FC<ConfirmationProps> = ({
    onClickResend,
    blurb,
    subtitle,
}) => {
    const [buttonClicked, setButtonClicked] = useState<boolean>(false)
    const handleClick = () => {
        onClickResend()
        setButtonClicked(true)
    }
    const handleLinkClick = () => {
        setButtonClicked(false)
    }
    return (
        <SignUpSignIn title="Check Your Inbox">
            <StyledConfirmationContainer>
                <Typography variant="subtitle1">{subtitle}</Typography>
                <Typography variant="body1">{blurb}</Typography>
                <div>
                    <Button onClick={handleClick} disabled={buttonClicked}>
                        Resend Email
                    </Button>
                    <Typography variant="body2" color="textSecondary">
                        Click{' '}
                        <StyledLink href="/login" onClick={handleLinkClick}>
                            here
                        </StyledLink>{' '}
                        to return to login
                    </Typography>
                </div>
            </StyledConfirmationContainer>
            <StyledSubtext>
                <Typography variant="body2">
                    Having Trouble Logging In?
                </Typography>
                <StyledLink href={'mailto:registration@cpiny.com'}>
                    Contact Support
                </StyledLink>
            </StyledSubtext>
        </SignUpSignIn>
    )
}

export default Confirmation
